import ClientPortalEmployeeAccessLevelAreaTypes from "../../Types/ClientPortalEmployeeAccessLevelAreaTypes"

const addEalaBoiler: ClientPortalEmployeeAccessLevelAreaTypes = {
    EmployeeAccessLevelAreaID: 0,
    EmployeeID: 0,
    AccessLevelID: 0,
    StateID: 0,
    ProfitCenterID: 0,
    ServiceAreaID: 0,
    IsDefault: 0,
    Inactive: false,
    ContactCode: 0,
    CanViewTime: true,
    CanEditTime: false,
    LimitToSupervisorEmployees: false,
    CanEditSQI: false,
    CanViewDashboard: false,
    IsWorkingProfitCenter: false
}
export default addEalaBoiler